(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-hero-sound-toggle]');
    if (!btn) return;
    var hero = btn.closest('.hero');
    if (!hero) return;
    var videos = hero.querySelectorAll('video');
    var turnOn = btn.getAttribute('aria-pressed') !== 'true';
    videos.forEach(function (v) {
      v.muted = !turnOn;
      if (turnOn) {
        v.volume = 1;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    });
    btn.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
    btn.setAttribute('aria-label', turnOn ? 'Mute video' : 'Unmute video');
    var label = btn.querySelector('.hero__sound-label');
    if (label) label.textContent = turnOn ? 'Sound on' : 'Sound off';
  });

  /* ------------------------------------------------------------------
     Keep the hero description box from ever covering the "OFF PISTE"
     headline. The headline is sized in vw (grows TALLER as the window
     widens) while the hero height tracks the window HEIGHT, so on short
     and/or wide windows the bottom-anchored description box can grow up
     into the letters. We measure the headline's bottom and, if the box
     intrudes, shrink the box from its bottom edge (via the --desc-fit
     scale) by exactly enough to clear it. Runs on load + resize.
  ------------------------------------------------------------------ */
  (function () {
    var MARGIN = 6;   // px of clearance we keep below the headline
    var MIN = 0.5;    // never shrink the box below this (keeps text readable)

    function fitHeroDesc() {
      document.querySelectorAll('.hero').forEach(function (hero) {
        // The display headline is the hero's own top-level text block, and the
        // description is the one nested in the bottom-bar group. Identified by
        // position, not by tag: the headline is an <h2> and the description's
        // first line is the page's <h1>, so a tag test would pick the wrong one.
        var h1 = hero.querySelector('.hero__content-wrapper > [data-layer] > .text-block > *');
        if (!h1) return;
        var desc = null;
        hero.querySelectorAll('.hero__content-wrapper .group-block .text-block').forEach(function (el) {
          if (el.textContent.trim().length > 10) desc = el;
        });
        if (!desc) return;

        // Reset both levers, then measure at natural size.
        var stacked = window.matchMedia('(max-width: 749px)').matches;
        desc.style.setProperty('--desc-fit', '1');
        desc.style.setProperty('--desc-nudge', '0px');
        var hr = h1.getBoundingClientRect();
        var dr = desc.getBoundingClientRect();

        // If the box doesn't sit horizontally over the headline, it can't cover it.
        var hOverlap = Math.min(hr.right, dr.right) - Math.max(hr.left, dr.left);
        if (hOverlap <= 2) return;

        // How far the box top intrudes past (headline bottom + margin).
        var intrusion = (hr.bottom + MARGIN) - dr.top;
        if (intrusion <= 0) return; // already clear

        if (stacked) {
          // Stacked layout (box above the buttons): the box must stay the SAME
          // full width as the buttons below it, so DON'T scale (which would narrow
          // it). Instead push the box down into the gap above the buttons by just
          // enough to clear the headline. Capped so it never reaches the buttons.
          var nudge = Math.min(intrusion, 26);
          desc.style.setProperty('--desc-nudge', nudge.toFixed(1) + 'px');
        } else {
          // Side-by-side layout: shrink the box from its bottom edge (scaling the
          // top down by (1 - scale) * height). On a very short window the shrink
          // hits the readable MIN floor and can't fully clear the tall headline;
          // in that case push the leftover down (the headline stays untouched).
          if (dr.height <= 0) return;
          var scale = 1 - (intrusion / dr.height);
          if (scale < MIN) scale = MIN;
          desc.style.setProperty('--desc-fit', scale < 1 ? scale.toFixed(3) : '1');
          // Where the top lands after scaling from the fixed bottom edge.
          var scaledTop = dr.bottom - dr.height * scale;
          var residual = (hr.bottom + MARGIN) - scaledTop;
          if (residual > 0) {
            desc.style.setProperty('--desc-nudge', Math.min(residual, 70).toFixed(1) + 'px');
          }
        }
      });
    }

    var raf;
    function schedule() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(fitHeroDesc);
    }
    window.addEventListener('load', fitHeroDesc);
    window.addEventListener('resize', schedule);
    document.addEventListener('DOMContentLoaded', fitHeroDesc);
    if (document.readyState !== 'loading') fitHeroDesc();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
